import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Cake, BellRing, Heart, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { fmtWhen, useAdmin } from "./ui";

const JOBS = [["reminders", "Send tomorrow's reminders now", BellRing], ["birthdays", "Send today's birthday emails now", Cake], ["thankyous", "Send yesterday's thank-yous now", Heart]];

export const Automations = () => {
  const { data } = useAdmin("runs", "/admin/automations/runs");
  const [busy, setBusy] = useState("");
  const qc = useQueryClient();
  const run = async (job) => {
    setBusy(job);
    try {
      const { data: r } = await api.post("/admin/automations/run", { job });
      const res = r.results?.[0] || {};
      if (res.error) toast.error(res.error);
      else toast.success(res.skipped ? "This email is switched off in Site content" : `${res.sent} email${res.sent === 1 ? "" : "s"} sent`);
      qc.invalidateQueries({ queryKey: ["admin"] });
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(""); }
  };
  return (
    <div className="ad-card" data-testid="settings-automations">
      <h3>Automated emails</h3>
      <p className="muted-sm">Every day at 9 AM (Nassau time) clients get a reminder for tomorrow's appointments, Birthday Club members get their birthday offer, and clients whose confirmed or completed visit was yesterday get a thank-you with a rebooking button. Each person gets one per appointment / per year. Edit the wording or switch them off under the Emails tab.</p>
      <div className="req-actions">
        {JOBS.map(([job, label, Icon]) => (
          <button key={job} className="btn light" disabled={!!busy} onClick={() => run(job)} data-testid={`automation-run-${job}`}>
            {busy === job ? <Loader2 size={15} className="spin" /> : <Icon size={15} />} {label}
          </button>
        ))}
      </div>
      {data?.length > 0 && (
        <div className="ad-runs" data-testid="automation-runs">
          {data.slice(0, 6).map((r) => (
            <div className="ad-row" key={r._id}>
              <span>{fmtWhen(r.started_at)} · {r.source || "running"}</span>
              <strong>{(r.results || []).map((x) => `${x.job}: ${x.error ? "error" : x.skipped ? "off" : x.sent}`).join(" · ") || "…"}</strong>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
